import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export const IconShowMore = ({
  direction = 'down',
  ...props
}: SvgIconProps & {
  direction?: 'up' | 'down'
}) => {
  let rotateValue

  switch (direction) {
    case 'down': {
      rotateValue = 'rotate(0deg)'
      break
    }
    case 'up': {
      rotateValue = 'rotate(180deg)'
      break
    }
  }

  return (
    <SvgIcon {...props} viewBox="0 0 18 18" sx={{ transform: rotateValue }}>
      <g id="Iconex/Light/Down circle">
        <g id="Down">
          <path
            id="Vector"
            d="M6.6 8.02501L8.48791 10.0581C8.78463 10.3777 9.29037 10.3777 9.5871 10.0581L11.475 8.02501M1.5 9C1.5 13.1421 4.85786 16.5 9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9Z"
            stroke="currentColor"
            fill="transparent"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </g>
      </g>
    </SvgIcon>
  )
}
